"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardResponseObjectToJSON = exports.RewardResponseObjectFromJSONTyped = exports.RewardResponseObjectFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function RewardResponseObjectFromJSON(json) {
    return RewardResponseObjectFromJSONTyped(json, false);
}
exports.RewardResponseObjectFromJSON = RewardResponseObjectFromJSON;
function RewardResponseObjectFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'rewardType': (0, _1.RewardTypeFromJSON)(json['rewardType']),
        'amountUnit': !(0, runtime_1.exists)(json, 'amountUnit') ? undefined : (0, _1.AmountUnitFromJSON)(json['amountUnit']),
        'amount': json['amount'],
        'promoDescriptions': !(0, runtime_1.exists)(json, 'promoDescriptions') ? undefined : json['promoDescriptions'],
        'nftUri': !(0, runtime_1.exists)(json, 'nftUri') ? undefined : json['nftUri'],
        'nftMintDate': !(0, runtime_1.exists)(json, 'nftMintDate') ? undefined : json['nftMintDate'],
    };
}
exports.RewardResponseObjectFromJSONTyped = RewardResponseObjectFromJSONTyped;
function RewardResponseObjectToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'rewardType': (0, _1.RewardTypeToJSON)(value.rewardType),
        'amountUnit': (0, _1.AmountUnitToJSON)(value.amountUnit),
        'amount': value.amount,
        'promoDescriptions': value.promoDescriptions,
        'nftUri': value.nftUri,
        'nftMintDate': value.nftMintDate,
    };
}
exports.RewardResponseObjectToJSON = RewardResponseObjectToJSON;
